/* tslint: disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v7.7.6173.30627 (NJsonSchema v5.19.6171.28316) (http://NSwag.org)
// </auto-generated>
//----------------------

//import 'rxjs/Rx'; 
import {Observable} from 'rxjs/Observable';
import {Injectable, Inject, Optional, InjectionToken} from '@angular/core';
import {Http, Headers, Response, RequestOptionsArgs} from '@angular/http';

export const API_BASE_URL = new InjectionToken('API_BASE_URL');

@Injectable()
export class LogApiService {
    private http: Http = null; 
    private baseUrl: string = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(Http) http: Http, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http; 
        this.baseUrl = baseUrl ? baseUrl : ""; 
    }

    createLogEntry(logEntry: LogEntry): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Log/CreateLogEntry";

        const content_ = JSON.stringify(logEntry ? logEntry.toJS() : null);
        
        return this.http.request(url_, {
            body: content_,
            method: "post",
            headers: new Headers({
                "Content-Type": "application/json; charset=UTF-8"
            })
        }).map((response) => {
            return this.processCreateLogEntry(response);
        }).catch((response: any, caught: any) => {
            if (response instanceof Response) {
                try {
                    return Observable.of(this.processCreateLogEntry(response));
                } catch (e) {
                    return <Observable<boolean>><any>Observable.throw(e);
                }
            } else
                return <Observable<boolean>><any>Observable.throw(response);
        });
    }

    private processCreateLogEntry(response: Response) {
        const data = response.text();
        const status = response.status.toString(); 

        if (status === "200") {
            let result200: boolean = null; 
            let resultData200 = data === "" ? null : JSON.parse(data, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200; 
        }
        else
        {
            throw new Error("error_no_callback_for_the_received_http_status"); 
        }
    }
}

export class LogEntry { 
    message: string; 
    accountId: string; 
    groupId: string; 
    userId: string; 
    deviceId: string; 
    policyId: string; 
    licenseId: string; 
    tagIds: string; 
    documentDBDatabaseName: string; 
    documentDBCollectionName: string; 
    severity: Severity;

    constructor(data?: any) {
        if (data !== undefined) {
            this.message = data["Message"] !== undefined ? data["Message"] : null;
            this.accountId = data["AccountId"] !== undefined ? data["AccountId"] : null;
            this.groupId = data["GroupId"] !== undefined ? data["GroupId"] : null;
            this.userId = data["UserId"] !== undefined ? data["UserId"] : null;
            this.deviceId = data["DeviceId"] !== undefined ? data["DeviceId"] : null;
            this.policyId = data["PolicyId"] !== undefined ? data["PolicyId"] : null;
            this.licenseId = data["LicenseId"] !== undefined ? data["LicenseId"] : null;
            this.tagIds = data["TagIds"] !== undefined ? data["TagIds"] : null;
            this.documentDBDatabaseName = data["DocumentDBDatabaseName"] !== undefined ? data["DocumentDBDatabaseName"] : null;
            this.documentDBCollectionName = data["DocumentDBCollectionName"] !== undefined ? data["DocumentDBCollectionName"] : null;
            this.severity = data["Severity"] !== undefined ? data["Severity"] : null;
        }
    }

    static fromJS(data: any): LogEntry {
        return new LogEntry(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Message"] = this.message !== undefined ? this.message : null;
        data["AccountId"] = this.accountId !== undefined ? this.accountId : null;
        data["GroupId"] = this.groupId !== undefined ? this.groupId : null;
        data["UserId"] = this.userId !== undefined ? this.userId : null;
        data["DeviceId"] = this.deviceId !== undefined ? this.deviceId : null;
        data["PolicyId"] = this.policyId !== undefined ? this.policyId : null;
        data["LicenseId"] = this.licenseId !== undefined ? this.licenseId : null;
        data["TagIds"] = this.tagIds !== undefined ? this.tagIds : null;
        data["DocumentDBDatabaseName"] = this.documentDBDatabaseName !== undefined ? this.documentDBDatabaseName : null;
        data["DocumentDBCollectionName"] = this.documentDBCollectionName !== undefined ? this.documentDBCollectionName : null;
        data["Severity"] = this.severity !== undefined ? this.severity : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        var json = this.toJSON();
        return new LogEntry(JSON.parse(json));
    }
}

export enum Severity {
    Trace = 0, 
    Warning = 1, 
    Error = 2, 
    Exception = 3, 
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/Crestron.HydrogenAPI.LogApi.service.ts